__turbopack_context__.v({
  "anchor": "app-badges-module-scss-module__KAYJcW__anchor",
  "icon": "app-badges-module-scss-module__KAYJcW__icon",
  "placeholder": "app-badges-module-scss-module__KAYJcW__placeholder",
  "wrapper": "app-badges-module-scss-module__KAYJcW__wrapper",
});
